import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppAlert } from '../../components/AppAlerts';

export default function AccessCodePage() {
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const notify = useAppAlert();

    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        try {
            const resp = await fetch('/api/season-state/verify-access', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code })
            });
            const json = await resp.json();
            if (json && json.valid) {
                localStorage.setItem('accessGranted', 'true');
                navigate('/');
            } else {
                const message = 'Invalid access code';
                setError(message);
                notify(message, 'error');
            }
        } catch (err) {
            const message = 'Network error';
            setError(message);
            notify(message, 'error');
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <div className="card p-4" style={{ maxWidth: 420, width: '100%' }}>
                <h5 className="mb-3">Enter Access Code</h5>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <input
                            className="form-control"
                            placeholder="Access code"
                            value={code}
                            onChange={e => setCode(e.target.value)}
                            required
                        />
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary" type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
